var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-steps"},_vm._l((_vm.maxSteps),function(i){return _c('div',{key:i,staticClass:"step",class:[i == _vm.step ? 'active' : '']})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }